import { render } from "./GestureIcon.vue?vue&type=template&id=35fcd4fc"
import script from "./GestureIcon.vue?vue&type=script&lang=ts"
export * from "./GestureIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script